import { FC } from "react";
import { BarItemProps } from "@nivo/bar";
import { Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { secondsToDisplayMinutes } from "utilities/oeeSummary";
import { TOeeDowntimeTopFiveChartRow } from "../../OeeDowntimeTopFiveByMachineCenterInterfaces";
import { useStyles } from "./OeeDowntimeTopFiveSegmentBar.styles";

export const toSegmentKey = (machineCenterId: string | number, failureTypeName: string | number): string =>
    JSON.stringify([Number(machineCenterId), String(failureTypeName)]);

/**
 * The shared chart hides Nivo's tooltip and only knows each segment's percent. Minutes
 * reach the segment through this closure rather than an extra row key, because the
 * shared chart turns every non-"Color" row key into a series.
 */
const createOeeDowntimeTopFiveSegmentBar = (secondsBySegment: ReadonlyMap<string, number>) => {
    const OeeDowntimeTopFiveSegmentBar: FC<BarItemProps<TOeeDowntimeTopFiveChartRow>> = ({ bar }) => {
        const classes = useStyles();
        const { t } = useTranslation();
        const failureType = String(bar.data.id);
        const minutes = secondsToDisplayMinutes(
            secondsBySegment.get(toSegmentKey(bar.data.data.machineCenterId, failureType)) ?? 0,
        );

        return (
            <Tooltip
                title={
                    <Typography className={classes.tooltipText}>
                        {t("locations.oee_summary_dashboard.downtime_top_five.tooltip", { failureType, minutes })}
                    </Typography>
                }
                placement="top"
                PopperProps={{ className: classes.tooltip }}
            >
                <g transform={`translate(${bar.x}, ${bar.y})`}>
                    <rect data-testid="oee-downtime-segment" width={bar.width} height={bar.height} fill={bar.color} />
                </g>
            </Tooltip>
        );
    };

    return OeeDowntimeTopFiveSegmentBar;
};

export default createOeeDowntimeTopFiveSegmentBar;
